import React from 'react';
import styles from './Reward.module.css';
import beastCoin from '../../assets/beastCoin.svg?url';
import star from '../../assets/star.svg?url';
import spinnerBall from '../../assets/spinnerBall.webp'

const Reward = ({
  reward,
  size,
  type,
}: {
  reward: number | string;
  size?: 'large';
  type?: 'star';
}) => {
  return typeof reward === 'string' ? (
    <>
      <div className={size === 'large' ? styles.large : styles.reward}>
        <div
          className={
            size === 'large' ? styles.rewardTextLarge : styles.rewardText
          }
        >
          {reward}
        </div>
      </div>
    </>
  ) : (
    <>
      <div className={size === 'large' ? styles.large : styles.reward}>
        <div
          className={
            size === 'large' ? styles.rewardTextLarge : styles.rewardText
          }
        >
          {reward}
        </div>
        {type === 'star' ? (
          <img src={star} alt="star" className={styles.rewardIcon} />
        ) : (
          <img src={spinnerBall} alt="beastCoin" className={styles.rewardIcon} />
        )}
      </div>
    </>
  );
};

export default Reward;
